import { Snackbar, IconButton, Button } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import styles from "./BulkPaymentTable.module.scss";

type ActionBarType = {
  selectedRows: number[];
  handleClearRowsSelection: () => void;
  handleDuplicateRow: () => void;
  removeRows: () => void;
  totalAmount: string;
};

const ActionBar = ({
  selectedRows,
  handleClearRowsSelection,
  handleDuplicateRow,
  removeRows,
  totalAmount,
}: ActionBarType) => {
  const { l10n } = useLocalization();

  return (
    <div className={styles.stickyContainer}>
      <Snackbar isActive={Boolean(selectedRows.length)}>
        <span className="fontColor--primary fontWeight--semibold">
          {`${selectedRows.length} ${l10n.getString(
            "snackbar-payment-selected",
            {
              totalSelected: selectedRows.length,
            }
          )}`}
        </span>
        <span className="fontColor--secondary">
          {l10n.getString("payment-total", {
            amount: totalAmount,
          })}
        </span>
        <IconButton
          kind="action"
          label="Close Actions"
          name="x"
          textSize="l"
          onClick={handleClearRowsSelection}
        />
        <Snackbar.Divider />
        <Snackbar.ButtonGroup>
          <Button
            disabled={selectedRows.length !== 1}
            kind="secondary"
            label={l10n.getString("label-duplicate")}
            testId="duplicate-payment-button"
            onClick={handleDuplicateRow}
          />
          <Button
            kind="primary"
            label={l10n.getString("button-delete")}
            testId="delete-payments-button"
            onClick={removeRows}
          />
        </Snackbar.ButtonGroup>
      </Snackbar>
    </div>
  );
};

export default ActionBar;
